import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'yt-fw-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {

 @Input() currentPage: number = 1;
  @Input() pageSize: number = 40;
  @Input() totalRecords: number = 0;
  @Output() pageChanged = new EventEmitter<number>();
  @Input() showLoader: boolean;

  getTotalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  changePage(page: number) {
    if (page < 1 || page > this.getTotalPages()) return;
    this.currentPage = page;
    this.pageChanged.emit(this.currentPage);
  }
}
